export interface Comic {
  id: number;
  title: string;
  author: string;
  category: string;
  categoryName: string;
  tags: string[];
  chapters: number;
  likes: number;
  status: string;
  updateTime: string;
  desc: string;
  cover: string;
}

export interface Category {
  key: string;
  name: string;
  icon: string;
  count: number;
  desc: string;
}

export const categories: Category[] = [
  { key: 'all', name: '全部', icon: 'ri-emotion-laugh-line', count: 3280, desc: '全网爆笑精选' },
  { key: 'school', name: '校园日常', icon: 'ri-graduation-cap-line', count: 420, desc: '上课睡觉、考试翻车的那些年' },
  { key: 'work', name: '职场打工人', icon: 'ri-briefcase-4-line', count: 380, desc: '加班改稿、开会有感' },
  { key: 'family', name: '家庭生活', icon: 'ri-home-smile-2-line', count: 310, desc: '爸妈和熊孩子的迷惑操作' },
  { key: 'love', name: '恋爱喜剧', icon: 'ri-heart-3-line', count: 350, desc: '恋爱脑与单身狗的快乐' },
  { key: 'sci', name: '脑洞科幻', icon: 'ri-rocket-2-line', count: 280, desc: '平行世界与人工智障' },
  { key: 'pets', name: '萌宠日常', icon: 'ri-heart-2-line', count: 460, desc: '猫狗成精系列' },
  { key: 'internet', name: '沙雕网友', icon: 'ri-user-smile-line', count: 520, desc: '网络迷惑行为大赏' },
  { key: 'food', name: '美食搞笑', icon: 'ri-restaurant-line', count: 360, desc: '干饭人的快乐星球' },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '我是打工人',
    author: '炭烧小笼包',
    category: 'work',
    categoryName: '职场打工人',
    tags: ['职场', '加班', '摸鱼'],
    chapters: 128,
    likes: 98600,
    status: '连载中',
    updateTime: '今日 09:20',
    desc: '每天早高峰挤地铁、深夜改PPT，社畜的快乐与崩溃全在这里。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20cartoon%20comic%20cover%20of%20a%20tired%20young%20office%20worker%20with%20big%20eye%20bags%20holding%20a%20large%20coffee%20cup%20at%20a%20messy%20desk%20with%20laptop%20and%20piles%20of%20documents%2C%20funny%20exhausted%20expression%2C%20warm%20cream%20background%2C%20playful%20minimalist%20illustration%20style&width=600&height=800&seq=comic-work-01&orientation=portrait',
  },
  {
    id: 2,
    title: '办公室生存指南',
    author: '摸鱼大师兄',
    category: 'work',
    categoryName: '职场打工人',
    tags: ['职场', '开会', '段子'],
    chapters: 96,
    likes: 74200,
    status: '连载中',
    updateTime: '昨日 18:40',
    desc: '从会议摸鱼到甩锅技巧，一部手把手教你职场快乐的搞笑手册。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20cartoon%20comic%20cover%20of%20a%20funny%20meeting%20scene%20with%20a%20boss%20pointing%20at%20a%20whiteboard%20while%20workers%20hide%20behind%20laptops%20yawning%2C%20comical%20expressions%2C%20warm%20cream%20background%2C%20playful%20minimalist%20illustration%20style&width=600&height=800&seq=comic-work-02&orientation=portrait',
  },
  {
    id: 3,
    title: '麻辣教师求生记',
    author: '数学老师姓王',
    category: 'school',
    categoryName: '校园日常',
    tags: ['校园', '老师', '考试'],
    chapters: 150,
    likes: 112300,
    status: '连载中',
    updateTime: '今日 08:05',
    desc: '当你以为老师很凶，其实他们天天在讲台前疯狂求生。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20cartoon%20comic%20cover%20of%20a%20strict%20teacher%20in%20glasses%20holding%20a%20pointer%20chasing%20two%20frightened%20funny%20students%20in%20a%20classroom%2C%20comical%20motion%20lines%2C%20warm%20cream%20background%2C%20playful%20minimalist%20illustration%20style&width=600&height=800&seq=comic-school-01&orientation=portrait',
  },
  {
    id: 4,
    title: '迟到大王的日常',
    author: '闹钟不会响',
    category: 'school',
    categoryName: '校园日常',
    tags: ['校园', '迟到', '早起'],
    chapters: 88,
    likes: 65800,
    status: '已完结',
    updateTime: '3天前更新',
    desc: '无论定几个闹钟都叫不醒的选手，如何在迟到路上极限狂奔。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20cartoon%20comic%20cover%20of%20a%20frantic%20student%20running%20with%20a%20backpack%20while%20holding%20a%20ringing%20alarm%20clock%20and%20wearing%20one%20shoe%2C%20speedy%20motion%20lines%2C%20warm%20cream%20background%2C%20playful%20minimalist%20illustration%20style&width=600&height=800&seq=comic-school-02&orientation=portrait',
  },
  {
    id: 5,
    title: '我家猫成精了',
    author: '喵酱本喵',
    category: 'pets',
    categoryName: '萌宠日常',
    tags: ['猫咪', '成精', '铲屎官'],
    chapters: 176,
    likes: 158900,
    status: '连载中',
    updateTime: '今日 11:30',
    desc: '会做饭、会开门、还会嫌弃你，这只猫到底是不是成精了？',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20cartoon%20comic%20cover%20of%20a%20smart%20fluffy%20cat%20standing%20on%20two%20legs%20wearing%20a%20tiny%20apron%20holding%20a%20frying%20pan%2C%20smug%20expression%2C%20warm%20cream%20background%2C%20playful%20minimalist%20illustration%20style&width=600&height=800&seq=comic-pets-01&orientation=portrait',
  },
  {
    id: 6,
    title: '狗子的内心戏',
    author: '拆家第一名',
    category: 'pets',
    categoryName: '萌宠日常',
    tags: ['狗狗', '内心', '拆家'],
    chapters: 102,
    likes: 89700,
    status: '连载中',
    updateTime: '昨日 20:15',
    desc: '在狗子眼里，沙发是零食、拖鞋是玩具、你回家是它一天的戏份。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20cartoon%20comic%20cover%20of%20a%20funny%20dog%20with%20dramatic%20wide%20eyes%20holding%20a%20chewed%20slipper%20in%20its%20mouth%2C%20guilty%20yet%20innocent%20expression%2C%20warm%20cream%20background%2C%20playful%20minimalist%20illustration%20style&width=600&height=800&seq=comic-pets-02&orientation=portrait',
  },
  {
    id: 7,
    title: '恋爱脑自救指南',
    author: '青梅煮酒',
    category: 'love',
    categoryName: '恋爱喜剧',
    tags: ['恋爱', '约会', '翻车'],
    chapters: 134,
    likes: 121000,
    status: '连载中',
    updateTime: '今日 14:00',
    desc: '从心动到翻车的全过程，每一次约会都是一场大型社死现场。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20cartoon%20comic%20cover%20of%20a%20funny%20couple%20on%20a%20date%20with%20heart%20eyes%20and%20clashing%20awkward%20poses%2C%20one%20blushing%2C%20romantic%20yet%20comical%2C%20warm%20cream%20background%2C%20playful%20minimalist%20illustration%20style&width=600&height=800&seq=comic-love-01&orientation=portrait',
  },
  {
    id: 8,
    title: '单身狗的快乐',
    author: '今天也不想脱单',
    category: 'love',
    categoryName: '恋爱喜剧',
    tags: ['单身', '快乐', '干饭'],
    chapters: 76,
    likes: 62400,
    status: '已完结',
    updateTime: '5天前更新',
    desc: '一个人看电影、一个人吃火锅、一个人在家快乐到飞起。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20cartoon%20comic%20cover%20of%20a%20very%20happy%20single%20person%20sitting%20alone%20on%20a%20couch%20with%20popcorn%20and%20a%20movie%20screen%2C%20gleeful%20expression%2C%20warm%20cream%20background%2C%20playful%20minimalist%20illustration%20style&width=600&height=800&seq=comic-love-02&orientation=portrait',
  },
  {
    id: 9,
    title: '火锅英雄传',
    author: '毛肚去哪儿了',
    category: 'food',
    categoryName: '美食搞笑',
    tags: ['火锅', '干饭', '江湖'],
    chapters: 118,
    likes: 97600,
    status: '连载中',
    updateTime: '今日 12:40',
    desc: '一场关于毛肚、鸭肠和蘸料江湖的爆笑史诗。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20cartoon%20comic%20cover%20of%20a%20steaming%20hotpot%20with%20happy%20little%20food%20characters%20like%20meat%20balls%20and%20tripe%20holding%20tiny%20swords%2C%20heroic%20funny%20pose%2C%20warm%20cream%20background%2C%20playful%20minimalist%20illustration%20style&width=600&height=800&seq=comic-food-01&orientation=portrait',
  },
  {
    id: 10,
    title: '深夜食堂保卫战',
    author: '泡面配枸杞',
    category: 'food',
    categoryName: '美食搞笑',
    tags: ['夜宵', '泡面', '干饭'],
    chapters: 84,
    likes: 58700,
    status: '连载中',
    updateTime: '昨日 23:50',
    desc: '凌晨一点的泡面，比任何米其林都香，这是干饭人的信仰。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20cartoon%20comic%20cover%20of%20a%20happy%20person%20enjoying%20a%20huge%20bowl%20of%20steaming%20noodles%20at%20a%20midnight%20table%20with%20a%20moon%20window%2C%20blissful%20funny%20expression%2C%20warm%20cream%20background%2C%20playful%20minimalist%20illustration%20style&width=600&height=800&seq=comic-food-02&orientation=portrait',
  },
  {
    id: 11,
    title: '平行世界的我',
    author: '二分之一的我',
    category: 'sci',
    categoryName: '脑洞科幻',
    tags: ['平行世界', '脑洞', '反转'],
    chapters: 92,
    likes: 73900,
    status: '连载中',
    updateTime: '今日 16:20',
    desc: '另一个世界的我居然是个大老板？世界线交汇的爆笑日常。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20cartoon%20comic%20cover%20of%20two%20identical%20versions%20of%20a%20character%20meeting%20in%20a%20portal%20mirror%2C%20one%20in%20pajamas%20one%20in%20a%20suit%2C%20confused%20funny%20expressions%2C%20warm%20cream%20background%2C%20playful%20minimalist%20illustration%20style&width=600&height=800&seq=comic-sci-01&orientation=portrait',
  },
  {
    id: 12,
    title: '人工智能先疯',
    author: '代码写崩了',
    category: 'sci',
    categoryName: '脑洞科幻',
    tags: ['AI', '机器人', '反转'],
    chapters: 66,
    likes: 51200,
    status: '连载中',
    updateTime: '3天前更新',
    desc: '当扫地机器人拥有自我意识，人类和AI的较量才刚刚开始。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20cartoon%20comic%20cover%20of%20a%20cute%20round%20robot%20with%20a%20glitchy%20chaotic%20screen%20face%20and%20sparks%20coming%20from%20its%20head%2C%20causing%20mischief%2C%20warm%20cream%20background%2C%20playful%20minimalist%20illustration%20style&width=600&height=800&seq=comic-sci-02&orientation=portrait',
  },
  {
    id: 13,
    title: '网友迷惑行为大赏',
    author: '热搜搬运工',
    category: 'internet',
    categoryName: '沙雕网友',
    tags: ['网友', '梗', '迷惑'],
    chapters: 142,
    likes: 145600,
    status: '连载中',
    updateTime: '今日 13:10',
    desc: '把全网沙雕网友的迷惑操作画出来，看完直呼这都能行？',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20cartoon%20comic%20cover%20of%20a%20row%20of%20funny%20people%20staring%20at%20their%20phones%20with%20shocked%20and%20amused%20expressions%2C%20floating%20meme%20emoticons%20around%2C%20warm%20cream%20background%2C%20playful%20minimalist%20illustration%20style&width=600&height=800&seq=comic-net-01&orientation=portrait',
  },
  {
    id: 14,
    title: '网购翻车实录',
    author: '七天无理由',
    category: 'internet',
    categoryName: '沙雕网友',
    tags: ['网购', '翻车', '快递'],
    chapters: 108,
    likes: 83600,
    status: '连载中',
    updateTime: '昨日 15:30',
    desc: '图片仅供参考系列，买家和卖家秀之间隔着一整个太平洋。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20cartoon%20comic%20cover%20of%20a%20surprised%20person%20opening%20a%20cardboard%20parcel%20box%20with%20clothes%20and%20odd%20objects%20flying%20out%2C%20shocked%20funny%20face%2C%20warm%20cream%20background%2C%20playful%20minimalist%20illustration%20style&width=600&height=800&seq=comic-net-02&orientation=portrait',
  },
  {
    id: 15,
    title: '爸妈的迷惑操作',
    author: '母上大人驾到',
    category: 'family',
    categoryName: '家庭生活',
    tags: ['爸妈', '家庭', '迷惑'],
    chapters: 120,
    likes: 105800,
    status: '连载中',
    updateTime: '今日 10:50',
    desc: '父母那些让人哭笑不得的神操作，看完想给你妈打个电话。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20cartoon%20comic%20cover%20of%20two%20funny%20parents%20struggling%20with%20a%20smartphone%20and%20a%20laptop%2C%20comically%20confused%20expressions%2C%20cozy%20living%20room%2C%20warm%20cream%20background%2C%20playful%20minimalist%20illustration%20style&width=600&height=800&seq=comic-fam-01&orientation=portrait',
  },
  {
    id: 16,
    title: '熊孩子图鉴',
    author: '被拆家的老父亲',
    category: 'family',
    categoryName: '家庭生活',
    tags: ['熊孩子', '家庭', '崩溃'],
    chapters: 90,
    likes: 69300,
    status: '已完结',
    updateTime: '6天前更新',
    desc: '神兽出没请注意，每个熊孩子背后都有一个欲哭无泪的家长。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20cartoon%20comic%20cover%20of%20a%20naughty%20cute%20child%20drawing%20on%20a%20wall%20with%20crayons%20while%20a%20helpless%20parent%20watches%20with%20hands%20on%20head%2C%20funny%20chaos%2C%20warm%20cream%20background%2C%20playful%20minimalist%20illustration%20style&width=600&height=800&seq=comic-fam-02&orientation=portrait',
  },
];

export const hotRanking: Comic[] = [
  { ...comics[4] },
  { ...comics[12] },
  { ...comics[0] },
  { ...comics[6] },
  { ...comics[8] },
  { ...comics[14] },
];

export const editorPicks: Comic[] = [comics[0], comics[6], comics[12]];

export const faqs = [
  {
    q: '哈哈漫画网上的漫画真的免费吗？',
    a: '是的，本站收录的搞笑漫画与爆笑漫画合集目前均免费在线阅读，无需付费即可轻松追更，专治不开心不花一分钱。',
  },
  {
    q: '如何一键追更喜欢的作品？',
    a: '在漫画卡片上点击「追更」按钮即可收藏该作品，更新后会第一时间提醒你，再也不用担心错过最新的爆笑章节。',
  },
  {
    q: '多久更新一次内容？',
    a: '编辑团队每日定时更新热门搞笑条漫，通常在上午和晚间两批上新，热门连载作品每周保持 2-3 次稳定更新。',
  },
  {
    q: '移动端可以看漫画吗？',
    a: '可以。哈哈漫画网针对电脑、平板和手机做了全面适配，横屏竖屏都能流畅阅读，碎片时间随时随地笑一笑。',
  },
  {
    q: '可以投稿或推荐好看的搞笑漫画吗？',
    a: '当然可以！欢迎通过页脚联系方式向我们投稿或推荐你心中的爆笑神作，经过审核后会以你的署名推荐上线。',
  },
  {
    q: '为什么有些作品标注「已完结」？',
    a: '已完结代表该漫画的全部章节已更新完毕，可以一口气从头笑到尾；标注「连载中」的作品则会持续上新，敬请期待。',
  },
];

export const testimonials = [
  {
    name: '加班的苦咖啡',
    role: '社畜一枚',
    avatar: 'T',
    text: '每天下班前都要来哈哈漫画网刷两话《我是打工人》，看完当场满血复活，老板看到我笑都以为我疯了。',
    icon: 'ri-double-quotes-l',
  },
  {
    name: '猫奴本奴',
    role: '铲屎官',
    avatar: '猫',
    text: '《我家猫成精了》简直画的就是我家主子！边看边笑边对号入座，追更三年一次都没落下。',
    icon: 'ri-double-quotes-l',
  },
  {
    name: '干饭第一名',
    role: '干饭人',
    avatar: '饭',
    text: '吃火锅必须配《火锅英雄传》，一口毛肚一页漫画，快乐到飞起。强烈推荐给所有吃货！',
    icon: 'ri-double-quotes-l',
  },
];